<template>
  <button
    class="close_button"
    @click="emit('click', $event)"
  >
    <i class="icon icon_cross" />
  </button>
</template>
<script setup>
const emit = defineEmits(['click']);
</script>
<style scoped lang="scss">
@use "~/_variables" as variables;

.close_button {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
